module.exports = __webpack_public_path__ + "static/media/QuantityMinus.9845afc7.svg";